export interface ReputationItem {
  id: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  location: string;
}

export const reputationItems: ReputationItem[] = [
  {
    id: "rep-1",
    userName: "视频爱好者小王",
    avatar: "",
    rating: 5,
    content: "用了17c一起草在线大半年了，真的是我见过资源最全的免费视频平台。画质清晰流畅，更新速度也很快，新片上线基本都能第一时间看到。强烈推荐！",
    date: "2026-07-28",
    location: "北京",
  },
  {
    id: "rep-2",
    userName: "追剧达人小李",
    avatar: "",
    rating: 5,
    content: "作为一个重度追剧用户，17c一起草在线完全满足了我的需求。分类清晰，搜索方便，而且没有烦人的弹窗广告，观剧体验一级棒！",
    date: "2026-07-25",
    location: "上海",
  },
  {
    id: "rep-3",
    userName: "动漫迷小陈",
    avatar: "",
    rating: 5,
    content: "动漫资源超级全！新番更新几乎是同步的，而且画质选择多，网速好的时候看4K简直是一种享受。已经推荐给了身边所有喜欢看动漫的朋友。",
    date: "2026-07-20",
    location: "广州",
  },
  {
    id: "rep-4",
    userName: "纪录片控老张",
    avatar: "",
    rating: 4,
    content: "纪录片频道做得很好，BBC、国家地理的经典作品基本都有。希望后续能增加更多国产优秀纪录片的资源，让更多人看到中国的好作品。",
    date: "2026-07-15",
    location: "深圳",
  },
  {
    id: "rep-5",
    userName: "学生党小明",
    avatar: "",
    rating: 5,
    content: "免费而且资源多，对没有收入的学生党来说太友好了。学习累了看看综艺解压，周末还能约同学一起看电影，生活品质直线上升。",
    date: "2026-07-10",
    location: "成都",
  },
  {
    id: "rep-6",
    userName: "影视从业者阿杰",
    avatar: "",
    rating: 5,
    content: "作为一个在影视行业工作的人，我不得不说17c一起草在线的内容生态做得相当专业。不仅资源全面，分类体系也很科学，用户体验做得非常到位。",
    date: "2026-07-05",
    location: "杭州",
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: "17c com一起草在线真的完全免费吗？",
    answer: "是的，17c com一起草在线是一个完全免费的在线视频播放平台。所有视频内容均免费开放观看，无需充值会员，无需付费订阅。我们致力于为所有用户提供优质、便捷的在线视频观看体验。",
  },
  {
    question: "观看视频需要下载播放器吗？",
    answer: "不需要。17c com一起草在线采用先进的在线播放技术，用户只需使用浏览器即可直接观看，无需下载任何播放器或插件。支持Chrome、Safari、Edge等主流浏览器。",
  },
  {
    question: "视频画质如何？支持高清播放吗？",
    answer: "我们提供多种画质选择，最高支持1080P全高清以及4K超高清画质播放。系统会根据您的网络状况自动推荐最佳画质，您也可以手动选择适合自己的清晰度。",
  },
  {
    question: "平台上有哪些类型的视频内容？",
    answer: "17c com一起草在线涵盖电影、电视剧、综艺、动漫、纪录片、体育、音乐、游戏等八大分类，拥有数万部视频资源。无论您喜欢什么类型的视频内容，都能在这里找到心仪的节目。",
  },
  {
    question: "新片更新速度快吗？",
    answer: "我们拥有专业的内容更新团队，热门新片、新剧、新番上线后会在第一时间更新到平台。通常院线电影下映后1-2个月内即可在平台观看，热门电视剧和动漫新番更是可以实现同步更新。",
  },
  {
    question: "在手机上可以观看吗？",
    answer: "当然可以。17c com一起草在线采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅、舒适的观看体验。",
  },
];